import React, { useEffect, useState } from 'react'
import { useTranslation } from '../../locale/useTranslation'
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { PUBLISH_REPORT, PUBLISH_TYPE } from '../../framework/constant/constant';
import { utility } from '../../framework/utility/utilityProvider';
import EPGForm from '../EPG/EPGForm';
import ScheduleExportForm from './ScheduleExportForm';
import ExportVodForm from '../MediaLibrary/NodeTreeView/ExportVodForm';

const PublishForm = () => {

    const lang = useTranslation();

    const [publishTypes, setPublishTypes] = useState([]);
    const [dataItem, setDataItem] = useState({});
    const [footerMessage, setFooterMessage] = useState('');

    useEffect(() => {
        loadCombo();
    }, []);

    const loadCombo = async () => {
        let publishTypesRes = Object.keys(PUBLISH_TYPE).map(key => ({
            _id: PUBLISH_TYPE[key],
            Description: key
        }));
        setPublishTypes(publishTypesRes);
        setDataItem({ ...dataItem, PublishType: { _id: PUBLISH_TYPE.VODCatalogue, Description: utility.getKeyByValue(PUBLISH_TYPE, PUBLISH_TYPE.VODCatalogue) } });
    }

    const onChange = (e) => {
        if (e.target.name == "PublishType") {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
            setFooterMessage('');
        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    }

    const renderPublishForm = (publishType) => {
        switch (publishType) {
            case PUBLISH_TYPE.VODCatalogue:
                return (<>
                    <ExportVodForm publishReport={PUBLISH_REPORT.VOD_CATALOGUE} setFooterMessage={setFooterMessage} />
                    <strong className='text-info' style={{ fontSize: "13px" }}>{footerMessage}</strong>
                </>);
            case PUBLISH_TYPE.EPGs:
                return (<>
                    <EPGForm setFooterMessage={setFooterMessage} />
                    <strong className='text-info' style={{ fontSize: "13px" }}>{footerMessage}</strong>
                </>);
            case PUBLISH_TYPE.ScheduleExport:
                return (<>
                    <ScheduleExportForm setFooterMessage={setFooterMessage} />
                    <strong className='text-info' style={{ fontSize: "13px" }}>{footerMessage}</strong>
                </>);
            default:
                return null;
        }
    };

    const borderStyle = {
        border: "1px solid #ced4da",
        boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
        backgroundColor: "#FAFAFA"
    }

    return (
        <div className='m-1'>
            <h1 className="page-title txt-color-bludeDark">
                <i className="fa fa-table marlr" style={{ fontSize: 20, color: 'GrayText' }} />
                <span>{lang.publish_page_breadcrumb}</span>
            </h1>

            <div className="row">
                <div className="col-3">
                    <label>{lang.publish_type_label}</label>
                    <DropDownList
                        data={publishTypes}
                        dataItemKey="_id"
                        textField="Description"
                        name="PublishType"
                        value={dataItem.PublishType}
                        onChange={onChange}
                    />
                </div>
            </div>
            {dataItem.PublishType?._id && <div className='mt-3'>
                <span style={{ fontSize: "17px", fontWeight: 400 }}>{dataItem.PublishType?.Description}</span>
                <div className="border p-2 form-group with-3d-effect" style={borderStyle}>
                    {renderPublishForm(dataItem.PublishType?._id)}
                </div>
            </div>}
        </div>
    );
};

export default PublishForm